import {Component, Input, OnInit} from '@angular/core';
import {AppConfig} from "../../app.config";
import {HttpService} from "../../services/http.service";


@Component({
    selector: 'app-social-panel',
    templateUrl: './social-panel.component.html'
})

export class SocialPanelComponent implements OnInit {
    @Input() public blog: any = {};
    public AppConfig = AppConfig;
    public emailList = '';
    public modalShow = false;

    public getBlogLink(blog) {
        return AppConfig.baseUrl + '/blog/details/' + blog.title.replace(' ', '-') + '-' + blog.id_article;
    }

    constructor(public http: HttpService) {
    }

    ngOnInit() {
    }

    shareFb(blog) {
        window.open(
            'https://www.facebook.com/share.php?u=' + this.getBlogLink(this.blog),
            'fbShareWindow',
            'height=450, width=550,toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
        );
    }

    shareTw(blog) {
        window.open(
            'https://twitter.com/intent/tweet?status=' + this.getBlogLink(this.blog),
            'fbShareWindow',
            'height=450, width=550,toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
        );
    }

    shareTumb(blog) {
        window.open(
            'http://www.tumblr.com/share/link?url=' + this.getBlogLink(this.blog),
            'fbShareWindow',
            'height=450, width=550,toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
        );
    }

    shareGr(blog) {
        window.open(
            'https://www.goodreads.com/update_status?url=' + this.getBlogLink(this.blog),
            'fbShareWindow',
            'height=450, width=550,toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
        );
    }

    sendToEmail() {
        this.modalShow = true;
        document.getElementsByTagName('body')[0].addEventListener('click', (ev) => {
            if ((ev.target['closest']('.send-form') === null && ev.target['closest']('.send-to-email') === null) || ev.target['closest']('.send-form') === false) {
                this.modalShow = false;
                this.emailList = '';
            }
        });
    }


    shareToEmail(event) {
        event.preventDefault();
        console.log(this.blog, 'blog');

        const formData = new FormData();
        const url = AppConfig.baseUrlApi + 'articles/send_email';

        if (this.emailList.toString().trim() === '') {
            alert('Field can\'t be empty');
            return;
        }

        const emailsList = this.emailList.split(',');
        const emails = [];

        for (let i = 0; i < emailsList.length; i++) {
            const email = emailsList[i].trim();
            if (!this.validateEmail(email)) {
                alert(email + ' is not valid email');
                return;
            } else {
                emails.push(email);
            }
        }

        formData.append('emails', emails.join(','));
        formData.append('id', this.blog.id_article);
        formData.append('link', AppConfig.baseUrl + AppConfig.getBlogLink(this.blog));

        this.sendRequest(url, formData);

    }

    validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    sendRequest(url, formData) {
        this.http.post(url, formData).subscribe(response => {
            if (response.message === 'ok') {
                alert('Message was sent');
                this.emailList = '';
                this.modalShow = false;
            } else {
                alert(response.content);
            }
        }, error => {
            console.log(error);
        });
    }
}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/blog/social-panel/social-panel.component.ts